import React, {useState} from 'react'

import {bool, combine} from '../styles/classname-utils'
import PricingPlanCard from './pricing-plan-card'
import {blueberry, brandHighlight, gray2, gray3} from '../styles/brand-colors'
import classes from './pricing-plan-table.module.scss'

const PricingPlanTable = ({showAnnualPricing}) => {
  const [show, setShow] = useState(0)

  const planGroup = (
    <>
      <div className={combine(classes.tableSubHeadCell, classes.tableSubHeadGray,
        'font8-bold')}
      >
        For individuals &amp;<br className='d-block d-md-none' /> small teams
      </div>
      <div className={combine(classes.tableSubHeadCell, classes.tableSubHeadHighlight,
        'font8-bold')}
      >
        For agencies &amp;<br className='d-block d-md-none' /> organizations
      </div>
    </>
  )

  return (
    <div className='row m-0 justify-content-center mt-3'>
      <div
        className={combine(classes.cardButtonSection,
          'd-flex d-lg-none flex-column col-12 col-sm-10 p-0')}
      >
        <div className={combine('d-flex', classes.tableSubHead)}>
          {planGroup}
        </div>
        <div
          role='group'
          className='btn-group btn-group-toggle d-flex justify-content-center'
        >
          <button
            type='button'
            className={combine('btn', classes.cardButton, bool(show === 0, 'active'))}
            onClick={() => setShow(0)}
          >
            Starter
          </button>
          <button
            type='button'
            className={combine('btn', classes.cardButton, bool(show === 1, 'active'))}
            onClick={() => setShow(1)}
          >
            Plus
          </button>
          <button
            type='button'
            className={combine('btn', classes.cardButton, bool(show === 2, 'active'))}
            onClick={() => setShow(2)}
          >
            Pro
          </button>
          <button
            type='button'
            className={combine('btn', classes.cardButton, bool(show === 3, 'active'))}
            onClick={() => setShow(3)}
          >
            Enterprise
          </button>
        </div>
      </div>

      <div className={combine(classes.tableContainer, 'row justify-content-center')}>
        <div className={combine('d-none d-lg-flex', classes.tableSubHead)}>
          {planGroup}
        </div>
        <div className={classes.tablePlanRow}>
          <PricingPlanCard
            name='Starter'
            description='Develop and publish your own web apps to 8thwall.com.'
            priceNumber={showAnnualPricing ? '9' : '12'}
            billingText={showAnnualPricing &&
              <><s>$144</s>&nbsp;<b>$108</b> / year</>
            }
            accentColor={gray2}
            hide={show !== 0}
          >
            <span><b>3</b> team members</span>
            <span>Unlimited WebAR and WebVR projects</span>
            <span>World Effects, Lightship VPS,{' '}
              <br className='d-block d-lg-none d-xl-block' />
              Image Targets and Face Effects
            </span>
            <span>100+ templates and modules</span>
            <span>Cloud Editor and free global hosting</span>
            <span>Launch projects from 8thwall.com</span>
            <span>Monetize with 8th Wall Payments</span>
            <span>Slack community support</span>
          </PricingPlanCard>
          <PricingPlanCard
            name='Plus'
            description={'Develop and publish your own web apps to 8thwall.com with ' +
            'access to direct project URLs and custom domains.'}
            priceNumber={showAnnualPricing ? '49' : '59'}
            billingText={showAnnualPricing &&
              <><s>$708</s>&nbsp;<b>$588</b> / year</>
            }
            accentColor={gray3}
            hide={show !== 1}
          >
            <span>Everything <b>Starter</b> has, plus:</span>
            <span><b>6</b> team members</span>
            <span>Launch projects from direct URLs</span>
            <span>Connect custom domains</span>
            <span>Embeddable AR</span>
            <span>Progressive Web Apps (PWAs)</span>
            <span>Email support</span>
          </PricingPlanCard>
          <PricingPlanCard
            name='Pro'
            description={'Develop campaigns, perform work-for-hire and purchase ' +
            'commercial licenses on behalf of brands.'}
            priceNumber={showAnnualPricing ? '99' : '129'}
            billingText={showAnnualPricing &&
              <><s>$1548</s>&nbsp;<b>$1188</b> / year</>
            }
            accentColor={brandHighlight}
            hide={show !== 2}
            highlight
          >
            <span>Everything <b>Plus</b> has, plus:</span>
            <span>Unlimited seats</span>
            <span>Self hosting with local development</span>
            <span>Password-protected staging URLs</span>
            <span>Purchase commercial licenses for clients</span>
            <span>Partner program eligibility</span>
            <span>Project permissions for external collaboration</span>
          </PricingPlanCard>
          <PricingPlanCard
            name='Enterprise'
            description={'Integrate 8th Wall into your technology stack and ' +
            'marketing funnel with access to platform APIs and licenses.'}
            accentColor={blueberry}
            hide={show !== 3}
          >
            <span>Everything <b>Pro</b> has, plus:</span>
            <span>Custom contracts and invoicing</span>
            <span>Commercial licenses included in contract</span>
            <span>Volume pricing</span>
            <span>Remove default splash screen</span>
            <span>Access to exclusive platform APIs</span>
            <span>Priority technical support</span>
          </PricingPlanCard>
        </div>
      </div>
    </div>
  )
}

export default PricingPlanTable
